export default [
  {
    title: 'مدیریت سفارش ها',
    icon: 'bx bx-store',
    children: [
      {
        title: 'سفارش ها',
        route: { name: 'order' },
        resource: 'OrderManager',
        action: 'show',
      },
    ],
  },
]
